module.exports = __webpack_public_path__ + "static/media/snaxa.649d11b8.jpg";